import { render } from "./OrderItemsCompartmentAssigningTable.html?vue&type=template&id=6944a7ab&scoped=true"
import script from "./OrderItemsCompartmentAssigningTable.js?vue&type=script&lang=js"
export * from "./OrderItemsCompartmentAssigningTable.js?vue&type=script&lang=js"

import "./OrderItemsCompartmentAssigningTable.css?vue&type=style&index=0&id=6944a7ab&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6944a7ab"]])

export default __exports__